import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ProvisionGroupListWidgetComponent } from '../provision-group-list-widget/provision-group-list-widget.component';

@Component({
    selector: 'app-formly-provision-group-list',
    templateUrl: './formly-provision-group-list.component.html',
    standalone: true,
    imports: [
        ProvisionGroupListWidgetComponent
    ]
})
export class FormlyProvisionGroupListComponent extends FieldType {


}
